import React from 'react'
import { useState } from 'react'
import { endPoints } from '../../../config/end-points';
import useHttp from '../../../hooks/use-http';

const AntiSpamModals = ({setShowAntiSpamModal}) => {

    const [agree,setAgree] = useState(false);

    const { sendRequest } = useHttp();

    const handleSubmit = () => {

        sendRequest(
            { url: endPoints.acceptTos, method: "GET"},
            (response) => {
              if (response.status === 200){
                setShowAntiSpamModal(false)
              }
            }
          );
    }
    return (
        <>
            <div className="modal fade show d-block" id="antispam" tabindex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Terms of services</h5> 
                        </div>
                        <div className="modal-body text-left">
                            <p>By checking this box, you acknowledge and agree that you will use the Vidamaze app in compliance with all applicable local, national, and international laws. The video and page creation functionality of this app must not be utilized for any illegal or unethical activities. Any violation of this agreement will result in a ban from the service. As the user, you are solely responsible for all pages and videos created using the Vidamaze app. You must not violate any copyright or terms and conditions. Please note that Vidamaze is not associated with or endorsed by Pixabay, Pexels, or any other company. In order to proceed, please check the box to confirm your agreement to these terms.</p>
                            <input 
                                type="checkbox" 
                                id="agreecheck" 
                                name="agree"  
                                value="0"
                                onClick={() => setAgree(!agree)}
                            /> I agree all the terms and conditions.
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="agreespam" className="btn btn-primary" disabled={!agree} onClick={handleSubmit}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AntiSpamModals